module.exports = __webpack_public_path__ + "media/images/lb/555-e25eb67000eacfad514f4f7d74cc2d48.svg";